<template>
    <!-- wrap : S -->
    <div @mousedown="searchCloseHandler">
        <!-- protocol_search_top : S -->
        <div class="protocol_search_top">
            <div class="protocol_search_input_wrap">
                <div class="protocol_search_input_area">
                    <platformSearch
                        :focusSearchInput               = "focusSearchInput"
                        :searchInputData                = "searchInputData"
                        :selectSearchProcessType        = "selectSearchProcessType"
                        :placeholder        = "'검색어를 입력하세요'"
                        :optionList         = "optionList"
                        :showFilter.sync    = "showFilter"
                        @inputEnter         = "inputEnter"
                        @checkOption        = "checkFunc"
                        @setSearchInputData = "(value) => {searchInputData  = value}"
                        @setFocusSearchInput= "(value) => {focusSearchInput = value}"
                        ref="protocolSearchList"   
                    />
                    <div class="protocol_search_chk">
                        <label for="chk01" class="component_checkbox">
                            <input type="checkbox" id="chk01" v-model="rescan" :checked="rescan">
                            <span>결과내 재검색</span>
                        </label>
                    </div>
                    <ul class="protocol_search_result">
                        <li v-for="(queryStack, index) in  requestBody.optionsAndQueries" :key="index">
                            <span>{{queryStack.query}}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <ul class="protocol_search_tab">
                <li :class="{on: selectSearchProcessType === ''}">
                    <a href="javascript:void(0);"
                       @click="selectSearchProcessType=''"
                    >전체
                    </a>
                </li>
                <li :class="{on: selectSearchProcessType === 'NORMAL'}">
                    <a href="javascript:void(0);"
                       @click="selectSearchProcessType='NORMAL'"
                    >공정도
                    </a>
                </li>
                <li :class="{on: selectSearchProcessType === 'ONLY_PROTOCOL'}">
                    <a href="javascript:void(0);"
                       @click="selectSearchProcessType='ONLY_PROTOCOL'"
                    >프로토콜
                    </a>
                </li>
            </ul>
        </div>
        <!-- protocol_search_top : E -->

        <!-- container : S -->
        <div class="ptc_container">
            <!-- protocol_search_container : S -->
            <div class="protocol_search_container">
                <div class="protocol_search_inner" v-if="processList.length != 0">
                    <div class="protocol_search_sort">
                        <p v-if="processList.length != 0"><strong>'{{ accumulateInputKeyword }}'</strong>에 대한 검색결과 총
                            <strong>{{ page?.totalElements }}</strong> 건</p>
                        <p v-else></p>
                        <select v-model="orderBy">
                            <option value="latest">최신순</option>
                            <option value="oldest">오래된순</option>
                        </select>
                    </div>

                    <ul class="protocol_search_list">
                        <li v-for="(item, i) in processList"
                            :key="i">
                            <newSearchProcess v-if="item.processType !== 'ONLY_PROTOCOL'"
                                              :processData="item"
                                              @goToProcessDetail="goToProcessDetail(item.processId,0)"
                                              @goToProtocolDetail="goToProtocolDetail"
                                              :thisMyPage=false
                                              :publishingActive="publishingActive"
                            />
                            <newSearchProtocol v-else
                                               :protocolData="item"
                                               @goToProcessDetail="goToProcessDetail(item.processId,0)"
                                               @goToProtocolDetail="goToProtocolDetail"
                                               :thisMyPage=false
                                               :publishingActive="publishingActive"
                            />
                        </li>
                    </ul>
                </div>
                <NewPagination :pageCnt="page?.pageNo" :pageTotalCnt="page?.totalPages" :size="9"
                               @click="selectPage({ pageNo: $event })"/>
                <div class="protocol_search_inner" v-if="processList.length == 0 && !loading">
                    <div class="search_nodata">
                        <h3><span>“{{ accumulateInputKeyword }}”</span> 검색 결과가 없습니다.</h3>
                        <ul>
                            <li>단어의 철자가 정확한지 확인해 주세요.</li>
                            <li>검색어의 단어 수를 줄이거나, 다른 검색어로 검색해 보세요.</li>
                            <li>보다 일반적인 검색어로 다시 검색해 보세요.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- protocol_search_container : E -->
        </div>
        <Loading :visible="loading"/>
        <!-- container : E -->
    </div>
    <!-- wrap : E -->
</template>

<script>
    import newSearchProcess from '@/components/platform_new/newSearchProcess'
    import newSearchProtocol from '@/components/platform_new/newSearchProtocol'
    import NewPagination from '@common/NewPagination'
    import platformSearch from "@common/platformSearch"
    import Loading from "@/components/common/loading";
    import Options from "@/components/nav_process/Editor/options";

    export default {
        components: {
            Options,
            newSearchProcess,
            newSearchProtocol,
            NewPagination,
            platformSearch,
            Loading,
        },
        data() {
            return {
                loading: true,
                processList: [],
                page: null,
                searchInputData: '',
                searchInputKeyword: '',
                selectSearchProcessType: '',
                orderBy: "latest",
                publishingActive: true,
                focusSearchInput: false,
                optionList: [],
                rescan: false,
                requestBody: {},
                checkSearch: false,
                accumulateInputKeyword: "",
                openFunction:true,
                showFilter: false,
            }
        },
        watch: {
            async selectSearchProcessType(value) {
                await this.resetOptions();
                this.resetPage();
                await this.search();
            },
            async orderBy(value){
                this.resetPage();
                await this.search();
            },
            async "$route.query.query"(value){
                this.searchInputData = value;
                this.resetPage();
                await this.search();
            },
        },
        async mounted() {
            this.resetPage();
            await this.checkUser();
            await this.resetOptions();
            const {query} = this.$route.query;
            this.searchInputKeyword = (this.searchInputData = query != '' ? query : '');
            await this.search();
        },
        methods: {
            async checkUser() {
                // 로그인 여부 확인.
                let userData = await this.$wApi.user.mypage.me();
                if(userData == null || userData?.error){
                    this.$router.push("/account/login");
                }
            },
            async selectPage(e) {
                this.page.pageNo = e.pageNo;
                await this.search();
            },
            inputEnter(event) {
                if (event.code === 'Enter' || event.keyCode === 13) {
                    this.showFilter = false;
                    this.$router.replace({
                        path : this.$route.path , 
                        query : {
                            query : this.searchInputData,
                        },
                    });
                    this.resetPage();
                    this.searchInputKeyword = this.searchInputData;
                    this.search();
                }
            },
            makeRequestBody(){
                let nowCheckList = [];
                this.optionList.filter(option => option.checked).forEach(option => {
                    nowCheckList.push(option.value);
                });
                let optionsAndQueries = {query: this.searchInputKeyword, targetFieldList: nowCheckList};
                
                if(this.rescan){
                    this.requestBody.pageNo = this.page.pageNo;
                    this.requestBody.perPage = this.page.perPage;
                    this.requestBody.orderBy = this.orderBy;
                    if(!this.requestBody.optionsAndQueries || this.requestBody.optionsAndQueries?.length == 0){
                        this.requestBody.optionsAndQueries = [];
                        this.requestBody.optionsAndQueries.push(optionsAndQueries);                        
                    }else{
                        let addFlag = true;
                        this.requestBody.optionsAndQueries.forEach(option => {
                            var newCheck = nowCheckList.filter(check => !option.targetFieldList.includes(check));
                            if(newCheck.length == 0 && option.query.trim() == this.searchInputKeyword.trim()){
                                addFlag = false;
                                return;
                            }
                        });
                        if(addFlag) {
                            this.requestBody.optionsAndQueries.push(optionsAndQueries);
                        }
                    }
                }else{
                    this.requestBody.pageNo = this.page.pageNo;
                    this.requestBody.perPage = this.page.perPage;
                    this.requestBody.orderBy = this.orderBy;
                    this.requestBody.optionsAndQueries = [];
                    this.requestBody.optionsAndQueries.push(optionsAndQueries);
                }
            },
            async search() {
                if(this.checkSearch){
                    return;
                }
                this.searchInputKeyword = this.searchInputData;
                this.processList = [];
                this.checkSearch = true;
                this.loading = true;
                try {
                    this.makeRequestBody();
                    this.setAccumulateInputKeyword();
                    let response = null;
                    if(this.selectSearchProcessType == ""){
                        this.requestBody.searchType = "all";
                    }else if(this.selectSearchProcessType == "NORMAL"){
                        this.requestBody.searchType = "process";
                    }else if(this.selectSearchProcessType == "ONLY_PROTOCOL"){
                        this.requestBody.searchType = "protocol";
                    }
                    response = await this.$wApi.process.release.search(this.requestBody);
                    if (response?.content) {
                        const {content, size, number, totalElements, totalPages} = response;
                        this.processList = content;
                        this.page = {
                            pageNo: number + 1,
                            perPage: size,
                            totalElements,
                            totalPages,
                        };
                    }else if(response.error){
                        window.alert(response.message);
                    }
                    /** 로그 등록 */
                    await this.$wApi.trace.log({
                        type: this.selectSearchProcessType == "ONLY_PROTOCOL" ? "PR" : "PD", //PD 공정도, PR 프로토콜
                        code: 'S', //N 생성 M 수정 S 검색 R 조회
                        subCode: '01',
                        keyword: this.searchInputKeyword,
                        result: response.totalElements,
                        ptlId: 0
                    });
                    this.checkSearch = false;
                    this.loading = false;
                } catch (error) {
                    this.checkSearch = false;
                    this.loading = false;
                    console.log(error)
                }
            },
            async goToProtocolDetail(protocolId, viewMode, tabIndex, beforeProcessId) {
                this.$router.push({
                    path: `/platform/detail`,
                    query: {
                        protocolId: protocolId,
                        viewMode: viewMode,
                        tabIndex: tabIndex,
                        searchInputData: this.searchInputData,
                        beforeProcessId: beforeProcessId,
                    },
                });
            },
            async goToProcessDetail(processId, tabIndex) {
                this.$router.push({
                    path: `/platform/detail`,
                    query: {
                        processId: processId,
                        tabIndex: tabIndex,
                        searchInputData: this.searchInputData,
                    },
                });
            },
            resetPage() {
                this.page = {
                    pageNo: 1,
                    perPage: 4,
                    totalElements: 0,
                    totalPages: 0,
                }
            },
            async resetOptions() {
                this.rescan = false;
                this.optionList = await this.$wApi.process.release.getOptions();
                this.optionList.forEach(option => {
                    if(option.value == "all"){
                        option.checked = true;
                    }else{
                        option.checked = false;                    
                    }
                });  
            },
            searchCloseHandler(e) {
                let {$refs: {protocolSearchList}} = this;
                if (!protocolSearchList.$el.contains(e.target)) { //추천검색어 또는 input 영역이 아니면 추천 검색어 종료
                    this.focusSearchInput = false;
                }
            },
            checkFunc(event, index){
                event.target.checked ? this.optionList[index].checked = true : this.optionList[index].checked = false;
            },
            setAccumulateInputKeyword(){ // 임시 작성
                if(!this.rescan){
                    this.accumulateInputKeyword = this.searchInputKeyword;
                }
                if(this.requestBody?.optionsAndQueries) {
                    this.accumulateInputKeyword = "";
                    this.requestBody.optionsAndQueries
                        .forEach(optionsAndQuerie => {
                            if (!(optionsAndQuerie.targetFieldList.includes("all") && optionsAndQuerie.query.trim().length == 0)) {
                                if (this.accumulateInputKeyword.length == 0 && optionsAndQuerie.query.trim().length > 0) {
                                    this.accumulateInputKeyword += optionsAndQuerie.query;
                                } else {
                                    this.accumulateInputKeyword += " > " + optionsAndQuerie.query;
                                }
                            }
                        });
                }
            },
        },
    }
</script>